/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusBadgeCounterDto } from '../../models/lexplus-badge-counter-dto';

export interface AufgabenControllerGetBadgeCounterForUserV1$Params {
}

export function aufgabenControllerGetBadgeCounterForUserV1(http: HttpClient, rootUrl: string, params?: AufgabenControllerGetBadgeCounterForUserV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusBadgeCounterDto>> {
  const rb = new RequestBuilder(rootUrl, aufgabenControllerGetBadgeCounterForUserV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusBadgeCounterDto>;
    })
  );
}

aufgabenControllerGetBadgeCounterForUserV1.PATH = '/v1/aufgaben/counter/pending';
